<div
  class="eb-added-favorites-to-cart"
  [cxFocus]="focusConfig"
  (esc)="dismissModal('Escape pressed')"
>
  <div class="eb-added-favorites-to-cart-container">
    <!-- Modal Header -->
    <ng-container *ngIf="loaded$ | async; else loading">
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          <ng-container *ngIf="addedEntriesWereMerged$ | async; else addedWithoutMerge">
            <ng-container *ngIf="addedEntries > 1; else singleAddWithMerge">
              {{ 'addFavoritesToCart.itemsIncrementedInYourCart' | cxTranslate }}
              {{
                'addFavoritesToCart.multipleEntriesAdded' | cxTranslate: { count: addedEntries - 1 }
              }}
            </ng-container>
            <ng-template #singleAddWithMerge>
              {{ 'addToCart.itemsIncrementedInYourCart' | cxTranslate }}
            </ng-template>
          </ng-container>
          <ng-template #addedWithoutMerge>
            <ng-container *ngIf="addedEntries > 1; else singleAddWithoutMerge">
              {{ 'addToCart.itemsAddedToYourCart' | cxTranslate }}
              {{
                'addFavoritesToCart.multipleEntriesAdded' | cxTranslate: { count: addedEntries - 1 }
              }}
            </ng-container>
            <ng-template #singleAddWithoutMerge>
              {{ 'addToCart.itemsAddedToYourCart' | cxTranslate }}
            </ng-template>
          </ng-template>
        </div>
        <button
          type="button"
          class="close"
          [attr.aria-label]="'common.close' | cxTranslate"
          (click)="dismissModal('Cross click')"
        >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>
      <!-- used for max order limit reached or entries without price -->
      <div class="additional-info-section">
        <cx-global-message></cx-global-message>
      </div>
      <!-- Modal Body -->
      <div class="cx-dialog-body modal-body">
        <div class="cx-dialog-row row">
          <div *ngIf="entry$ | async as entry" class="cx-dialog-item col-12">
            <eb-cart-item-header></eb-cart-item-header>
            <eb-cart-item
              [item]="entry"
              [compact]="false"
              [showAvailability]="false"
              [quantityControl]="getQuantityControl() | async"
              [promotionLocation]="promotionLocation"
            ></eb-cart-item>
          </div>
          <!-- Separator -->
          <div class="cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none"></div>
          <!-- Total container -->
          <div class="cx-dialog-actions col-12" *ngIf="cart$ | async as cart">
            <!-- Actions -->
            <div class="cx-dialog-buttons">
              <a
                [class.disabled]="form.dirty"
                [routerLink]="{ cxRoute: 'checkout' } | cxUrl"
                class="btn btn-secondary"
                (click)="dismissModal('Proceed To Checkout click')"
                >{{ 'addToCart.proceedToCheckout' | cxTranslate }}</a
              >
              <a
                [class.disabled]="form.dirty"
                [routerLink]="{ cxRoute: 'cart' } | cxUrl"
                class="btn btn-primary"
                (click)="dismissModal('View Cart click')"
                autofocus
                >{{ 'addToCart.viewCart' | cxTranslate }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #loading>
      <div class="cx-dialog-header modal-header">
        <div class="cx-dialog-title modal-title">
          {{ 'addToCart.updatingCart' | cxTranslate }}
        </div>
        <button
          type="button"
          class="close"
          [attr.aria-label]="'common.close' | cxTranslate"
          (click)="dismissModal('Cross click')"
        >
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>
      <!-- Modal Body -->
      <div class="cx-dialog-body modal-body">
        <div class="cx-dialog-row">
          <div class="col-sm-12">
            <eb-spinner></eb-spinner>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
